module.exports = __webpack_public_path__ + "img/automated-cleanup.24585744.png";